import React, { useEffect } from 'react'
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'react-feather';

const About = (props) => {

  // Adding custom class to body 
  useEffect(() => {
    props.location.pathname === '/' ? document.body.classList.add("home-class") : document.body.classList.add("custom-class");

    // Clear hamburger menu
    document.body.classList.remove("menu-closed");
    document.body.classList.remove("menu-opened");
  });

  return (
    <React.Fragment>
      <div id="about-page">
        <div className="about-page pt-24">
          {/* Hero Section */}
          <div className="about-hero">
            {/* <h3 className="heading4">Organic by MSL</h3> */}
            <div className='breadcrumbs'>
              <li><Link to='/'>Home</Link> <span>{'>'}</span> <Link to='/about-us' className='current'>About Us</Link></li>
            </div>
            <h4 className='heading3'>We Listen, We Think, We Engage, We Execute </h4>
            <p className='about-hero-body-copy'>Organic by MSL is a creative powerhouse that blends art, code, and copy to tell stories that captivate, engage, and inspire. Our team of digital content strategists, user experience architects, programmers, media specialists, and social media experts work together to ensure that our content reaches the right audience at the right time, making a measurable impact on brand love, reputation, and sales. </p>
            <img src='https://organic-by-msl.s3.amazonaws.com/website/about-us-banner.jpg' alt="About Featured" />
          </div>
          {/* Hero Section */}

          {/* About Section */}
          <div className="about-content-wrapper">
            <div className="about-content">
              <h1 className="heading3 pb-8">About Us</h1>
              <p>Over the last decade, the digital division of MSL, ORGANIC, has been evolving to become the industry leader in digital communications.</p>
              <p className='pt-6'>With our full-stack digital service, we partner with brands, programs and corporations to increase awareness and intent for their products and services. We follow a content-first approach with multi-media production that blends perfectly with our platform-agnostic planning and platform-specific execution. Over the years, we have collaborated with brands to grow their communities and drive impact through clutter-breaking and impactful campaigns.</p>
              <p className='pt-6'>We understand our stakeholders, equipping us to support corporations and tell a well-rounded story about their purpose, ethos, and commitment to their markets, talent, and consumers.</p>
              <p className='pt-6'>We specialise in executive profile building, talent communication, and ESG-related storytelling. Our citizen communication work with the government has equipped us to reach even media dark areas leveraging digital tactics and multimedia, multilingual content.</p>
              <p className='pt-6'>Our creative team has honed their skills over the last decade, leveraging audience insights to deliver compelling stories. We are the ideal partner for brands organizations, multi-business corporations, category creators, and product companies looking to reach wide audiences.</p>
            </div>

          </div>
          {/* About Section */}

          {/* Capabilities Section */}
          {/* <div className="about-capabilities">
                <h1 className="heading4">Capabilities</h1>
                <div className="capabilities-list">
                  <div>
                    <h2>Strategy</h2>
                    <ul>
                      <li>Digital Strategy</li>
                      <li>Content Strategy</li>
                      <li>Brand Experience</li>
                      <li>User Research</li>
                      <li>Data Analysis</li>
                      <li>Social Media Campaigns</li>
                    </ul>
                  </div>

                  <div>
                    <h2>Creative & Design</h2>
                    <ul>
                      <li>Design Direction</li>
                      <li>Storytelling</li>
                      <li>Branding & Identity</li>
                      <li>Web & Mobile UI</li>
                      <li>User Experience</li>
                      <li>Creative Concepts & Ideas</li>
                    </ul>
                  </div>

                  <div>
                    <h2>Development</h2>
                    <ul>
                      <li>Responsive Development</li>
                      <li>Front & Back End Development</li>
                      <li>Websites & Web Applications</li>
                      <li>E-Commerce</li>
                      <li>CMS & Microsites</li>
                      <li>APIs Development</li>
                    </ul>
                  </div>
                </div>
              </div> */}
          {/* Capabilities Section */}
        </div>
      </div>
  

      {/* Footer CTA Ribbon */}
      <section id='take-next-leap' key='about'>
        <div className='take-next-leap'>
          <div className='take-next-leap__left'>
            <h1 className="heading4 black">We’d love to talk, <span>collaborate and grow with you!</span></h1>
          </div>
          <div className='take-next-leap__right'>
            <p><Link to='/contact-us'>Drop in your details<ArrowUpRight /></Link></p>
          </div>
        </div>
      </section>
      {/* Footer CTA Ribbon */}

    </React.Fragment >
  )
}

export default About
